// Id string only, so server .mjs files can import it (registration lives in the
// plugin's .runtime.js). Enabled per client via an auth bundle holding the demand
// "feature-client-schedule-fields"; never globally.
export const FEATURE_FLAG_CLIENT_SCHEDULE_FIELDS = "client-schedule-fields"
